module.exports = __webpack_public_path__ + "static/media/Rahul.b905ed91.png";